import _ from 'lodash'
import { DateTime } from 'luxon'

export const icon = 'signal-stream'
export const humanName = {
  singular: 'Transmissão',
  plural: 'Transmissões'
}
export const status = [
  { slug: 'open', name: 'Aberto', variant: 'success' },
  {
    slug: 'soon',
    name: 'Em breve',
    variant: 'light-success'
  },
  { slug: 'closed', name: 'Encerrado', variant: 'secondary' }
]
export const getStatus = (props = {}) => {
  const { start_at, end_at } = props
  const now = DateTime.local()
  const startAt = DateTime.fromISO(start_at)
  const endAt = DateTime.fromISO(end_at)

  let slug = 'open'
  if (now < startAt) slug = 'soon'
  else if (endAt && endAt.isValid && now >= endAt) slug = 'closed'

  return _.find(status, { slug })
}
export const subliveStreamStatus = [
  { slug: 'pending', name: 'Aguardando aprovação', variant: 'warning' },
  { slug: 'approved', name: 'Aprovado', variant: 'success' },
  { slug: 'refused', name: 'Recusado', variant: 'danger' },
  { slug: 'awaiting_correction', name: 'Aguardando correção', variant: 'dark' }
]
export const getSubliveStreamStatus = slug =>
  _.find(subliveStreamStatus, { slug })
export const getConfig = props => {
  const { digitalProductId } = props
  const basePath = '/transmissoes'
  const apiBasePath = `/user/digital_products/${digitalProductId}/live_streams`
  const getBreadcrumbs = (breadcrumbs = []) => [
    {
      href: basePath,
      name: humanName.plural
    },
    ...breadcrumbs
  ]
  const config = {
    basePath,
    apiBasePath,
    icon,
    humanName,
    pagination: {
      per_page: 999
    },
    sort: {
      field: 'position',
      order: 'asc'
    },
    getBreadcrumbs,
    status,
    getStatus,
    subliveStreamStatus,
    getSubliveStreamStatus
  }

  return config
}
